import React, {FC} from 'react'
import {Panel, PanelGroup} from 'react-resizable-panels'
import {useLavanderia} from '../../../../../hooks/useLavanderia'
import ContainerWrapper from '../../componentes/Container'
import {renderPanelContent} from '../components'

const CheckInPageWrapper: FC = () => {
  const {currentTabItem} = useLavanderia()
  return (
    <ContainerWrapper>
      <PanelGroup autoSaveId='example' direction='vertical' style={{height: '100%'}}>
        <Panel
          collapsible={true}
          order={1}
          key={`panel-lavanderia-header-${currentTabItem.id}`}
          id={`panel-lavanderia-header-${currentTabItem.id}`}
          className={'panel__box'}
          defaultSize={50}
        >
          <>{renderPanelContent(currentTabItem.content.headerPanel)}</>
        </Panel>
      </PanelGroup>
    </ContainerWrapper>
  )
}

export default CheckInPageWrapper
